<template lang="pug">
.wrapper
    .main-container
        //- Header Global
        .relative
            HeaderGlobal(HeaderGlobalHeading="Media" :HeaderGlobalBreadcrumb="breadcrumb").py-4
            .mobile-only.btn-new-photo(
                @click="openUpload()"
            )
                button.btn-primary-o(type='submit')
                    .icon-btn
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                    span.ml-2 new photo

        .box.box--media
            .box--media__sidebar#mobileSidebarClose(
                v-bind:class="{'upload-mobile-hide' : !changePhoto }"
            )
                .mobile-only.text-light.w-full
                    .flex.items-center.justify-between.pb-4
                        h3 Upload Photo
                        button.btn-icon.btn-icon-40(
                            type='button'
                            @click="closeUpload()"
                        )
                            i.icon-btn
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                clipper-upload.btn-primary.w-full.mb-2(v-model="imgSrc" style="cursor: pointer;") Upload Photo 
                clipper-fixed.w-full.mb-2(
                    ref="clipper"
                    :src="imgSrc"
                    preview="fixed-preview"
                    :rotate="rotation"
                    :grid="true"
                    :corner="true"
                    shadow="rgba(0, 0, 0, 0.75)"
                    :ratio="ratio"
                    :wrapRatio="ratio"
                    :area="area"
                    :outline="outline"
                    :min-scale="min_scale"
                    bg-color="#000"
                    :zoomRate="zoomRate"
                )
                .range-rotate.py-1.px-2.border.rounded.mb-2.text-center
                    span.text-center.text-xs Rotate Photo
                    clipper-range(
                        v-model="rotation"
                        style="width: 100%"
                        :min="-180"
                        :max="180"
                    )

                .field.mb-2
                    .relative.style(style="min-width:200px")
                        select.field-style(v-model="limit")
                            option(v-if="limit.length > 0" v-for="(lim,index) in getLimit" :key="index" :value="lim") {{ lim }}
                        .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                div.flex.items-center.flex-wrap
                    .field.field--radio.mb-4(class="w-1/2")
                        .wrapper-radio
                            input(type="radio" name="radio" v-model="gender" value="male")
                            .ui-radio.flex.items-center
                                .radio.flex.items-center.justify-center
                                strong Male
                    .field.field--radio.mb-4(class="w-1/2")
                        .wrapper-radio
                            input(type="radio" name="radio" v-model="gender" value="female")
                            .ui-radio.flex.items-center
                                .radio.flex.items-center.justify-center
                                strong Female

                button.btn-primary-o.btn-large.btn-full.w-full.btn-primary--disabled(v-if="load_data_status_face_recognition.status === 'loading'" disabled="disabled" style="cursor: not-allowed;") Analyzing Photo...
                button.btn-primary-o.btn-large.btn-full.w-full(v-else @click="submit()") Analyze Photo
                    
            .box--media__content
                .flex.area-preview
                    .area-preview__thumbnail
                        .thumbnail-result
                            template(v-if="face_recognition.candidates && face_recognition.candidates.length > 0 && media.length > 0")
                                //- div.w-full.list-thumb(v-for="thumb in mediaDummies" :key="thumb.id")
                                div.w-full.list-thumb(v-for="(thumb, index) in media" :key="index")
                                    .thumbnail-result__selected(v-if="thumb.selected" @click="getDetailData(thumb.ktp_number, index)")
                                        .flex.p-2.border-b
                                            figure.cover-media
                                                img(v-if="thumb.FACE" :src="thumb.FACE" alt="")
                                                img(v-else :src="default_img" alt="")
                                            .block.pl-2
                                                strong.block {{ thumb.full_name ? thumb.full_name : '-' }}
                                                .text-xs {{ thumb.ktp_number ? thumb.ktp_number : '-'}}
                                                //- span {{ thumb.regent_name ? thumb.regent_name : '-' }}
                                                .text-xs Score: {{ thumb.score ? thumb.score : '-' }}
                                    .block(v-else)
                                        .flex.p-2.border-b(@click="getDetailData(thumb.ktp_number, index)")
                                            figure.cover-media
                                                img(v-if="thumb.FACE" :src="thumb.FACE" alt="")
                                                img(v-else :src="default_img" alt="")
                                            .block.pl-2
                                                strong.block {{ thumb.full_name ? thumb.full_name : '-' }}
                                                .text-xs {{ thumb.ktp_number ? thumb.ktp_number : '-'}}
                                                //- span {{ thumb.regent_name ? thumb.regent_name : '-' }}
                                                .text-xs Score: {{ thumb.score ? thumb.score : '-' }}
                    .area-preview__information
                        .preview(v-if="load_data_status_face_recognition.status === 'loading'")
                            .preview-blank.flex.items-center.justify-center
                                Loading(show="true")

                        template(v-else-if="face_recognition.candidates && face_recognition.candidates.length > 0 && media.length > 0")
                            .preview
                                .block.p-4.w-full
                                    .flex.flex-col.justify-start.items-start(
                                        class="lg:flex-row lg:items-center lg:justify-between"
                                    )
                                        .text-light.flex-grow(
                                            class="mb-6 lg:mb-0"
                                        )
                                            //- router-link(:to="media_detail.ktp_number ? '/result/'+ encryptNik(media_detail.ktp_number) +'/profile' : '/result/profile'" target="_blank")
                                            strong.block {{ media_detail.full_name }} {{ media_detail.score ? '(' + media_detail.score + ')' : '' }}
                                            span NIK : {{ media_detail.ktp_number }}
                                        .flex.items-center(
                                            class="justify-between flex-row-reverse w-full lg:flex-row lg:w-auto"
                                        )
                                            router-link.btn-default(
                                                :to="media_detail.ktp_number ? '/result/'+ encryptNik(media_detail.ktp_number) +'/profile' : '/result/profile'" target="_blank") View Detail Profile
                                            button.btn-primary.btn-full.ml-0(
                                                class="lg:ml-2"
                                            ) Save As Clue

                                .flex.-m-x-4.flex-wrap(
                                    class="flex-col-reverse lg:flex-row"
                                )
                                    .block.p-4(class="w-full lg:w-4/6").area-label-info
                                        .block
                                            .flex.mb-4.items-center.label-info
                                                span.text-light Gender
                                                h3.monospace {{ media_detail.sex ? media_detail.sex : '-' }}
                                            .flex.mb-4.items-center.label-info
                                                span.text-light Religion
                                                h3.monospace {{ media_detail.religion ? media_detail.religion : '-' }}
                                            .flex.mb-4.items-center.label-info
                                                span.text-light Marital
                                                h3.monospace {{ media_detail.marital_status ? media_detail.marital_status : '-' }}
                                            .flex.mb-4.items-center.label-info
                                                span.text-light Blood Type
                                                h3.monospace {{ media_detail.blood_type ? media_detail.blood_type : '-' }}
                                            .flex.mb-4.items-center.label-info
                                                span.text-light Place/Date Of Birth
                                                h3.monospace  {{ media_detail.birth_place ? media_detail.birth_place : '-' }}, {{ media_detail.date_of_birth ? media_detail.date_of_birth : '-' }}
                                            .flex.mb-4.items-center.label-info
                                                span.text-light Occupation
                                                h3.monospace {{ media_detail.occupation ? media_detail.occupation : '-' }}
                                            .flex.mb-4.items-center.label-info
                                                span.text-light Phone
                                                h3.monospace {{ media_detail.phone ? media_detail.phone : '-' }}
                                            .flex.mb-4.items-center.label-info
                                                span.text-light Nationality
                                                h3.monospace {{ media_detail.nationality ? media_detail.nationality : '-' }}
                                            .flex.mb-4.items-center.label-info
                                                span.text-light NKK
                                                h3.monospace {{ media_detail.family_cert_number ? media_detail.family_cert_number : '-' }}
                                                //- h3.monospace
                                                    router-link(:to="media_detail.ktp_number ? '/result/'+ encryptNik(media_detail.ktp_number) +'/profile#family' : ''" target="_blank")
                                                        | {{ media_detail.family_cert_number ? media_detail.family_cert_number : '-' }}
                                            .flex.mb-4.items-center.label-info
                                                span.text-light Address
                                                h3.monospace {{ media_detail.address ? media_detail.address : '-' }}
                                            .flex.mb-4.items-center.label-info
                                                span.text-light Village
                                                h3.monospace {{ media_detail.village ? media_detail.village : '-' }}
                                            .flex.mb-4.items-center.label-info
                                                span.text-light City
                                                h3.monospace {{ media_detail.regent_name ? media_detail.regent_name : '-' }}
                                            .flex.mb-4.items-center.label-info
                                                span.text-light Province
                                                h3.monospace {{ media_detail.province_name ? media_detail.province_name : '-' }}
                                            .flex.mb-4.items-center.label-info
                                                span.text-light Country
                                                h3.monospace {{ media_detail.country_name ? media_detail.country_name : '-' }}

                                    .block.p-4(class="w-full lg:w-2/6")

                                        div.text-center(v-if="loading_photo_ktp")
                                            .inline-block
                                                Spinner(show="true" size="100")

                                        //- img(v-else :src="photo_ktp" alt="" style="width: 100% !important; height: auto !important;" @error="getDefaultImage")
                                        img(v-else :src="media_detail.FACE ? media_detail.FACE : default_img" alt="" style="width: 100% !important; height: auto !important;" @error="getDefaultImage")
                                        
                                        //- for signature
                                        br
                                        img(v-if="media_detail.SIGNATURE" :src="media_detail.SIGNATURE" alt="" style="width: 100% !important; height: auto !important;")

                        .preview(v-else)
                            .preview-blank.flex.items-center.justify-center.pt-24
                                div.text-center
                                    template(v-if="load_data_status_face_recognition.status === 'failed'")
                                        .inline-block.mb-2
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32" stroke="currentColor" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
                                        h2 Failed get data
                                        p something worng

                                    template(v-else-if="load_data_status_face_recognition.status === 'empty' || load_data_status_face_recognition.status === 'partially-empty' || (load_data_status_face_recognition.status === true && media.length === 0)")
                                        .inline-block.mb-2
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32" stroke="currentColor" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
                                        h2 Data is empty
                                        p please try again

                                    template(v-else)
                                        .inline-block.mb-2
                                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-image"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline></svg>
                                        h2 Please upload a photo first
                                        p the information will show when a photo has uploaded
                                    

</template>

<script>
import { mapState } from 'vuex';
import HeaderGlobal from './../../components/HeaderGlobal.vue'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import { clipperFixed, clipperPreview, clipperRange, clipperUpload } from 'vuejs-clipper'
import { encrypt } from '@/util/crypto';
import Spinner from '@/components/Spinner.vue';
import Loading from '@/components/Loading.vue';

export default {
    name: 'PageMediaPhoto',
    components: {
        HeaderGlobal,
        VueSlickCarousel,
        clipperFixed,
        clipperPreview,
        clipperRange,
        clipperUpload,
        Spinner,
        Loading,
    },
    data() {
        return {
            changePhoto: true,
            breadcrumb: [
                {
                    name: 'Media',
                    url: '/media',
                },
            ],
            settingsThumbnail: {
                "dots": false,
                "infinite": true,
                "dotsClass": "slick-dots custom-dot-class",
                "edgeFriction": 0.35,
                "speed": 500,
                "slidesToShow": 5,
                "slidesToScroll": 1,
                "vertical": true,
                "verticalSwiping": true,
                "arrows": false,
            },

            settingsPreview: {
                "slidesToShow": 1,
                "slidesToScroll": 1,
                "fade": true,
            },

            getLimit: (process.env.VUE_APP_FACE_RECOGNITION_LIMIT ? process.env.VUE_APP_FACE_RECOGNITION_LIMIT.split(',') : [5,10,15,20,25]),
            limit: (process.env.VUE_APP_FACE_RECOGNITION_LIMIT ? process.env.VUE_APP_FACE_RECOGNITION_LIMIT.split(',')[0] : '5'),
            gender: 'male',
            media: [],
            media_detail: {},
            current_media_selected: null,

            mediaDummies: [
                {
                    id: 1,
                    name: 'PEVITA CLEO EILEEN PEARCE',
                    nik: '1234567890523456',
                    city: 'Bandung',
                    selected: true
                },
                
                {
                    id: 2,
                    name: 'PEVITA CLEO EILEEN PEARCE',
                    nik: '1234567890523456',
                    city: 'Bandung',
                    selected: false
                },
                {
                    id: 3,
                    name: 'PEVITA CLEO EILEEN PEARCE',
                    nik: '1234567890523456',
                    city: 'Bandung',
                    selected: false
                },
                {
                    id: 4,
                    name: 'PEVITA CLEO EILEEN PEARCE',
                    nik: '1234567890523456',
                    city: 'Bandung',
                    selected: false
                },
                {
                    id: 5,
                    name: 'PEVITA CLEO EILEEN PEARCE',
                    nik: '1234567890523456',
                    city: 'Bandung',
                    selected: false
                },
                {
                    id: 6,
                    name: 'PEVITA CLEO EILEEN PEARCE',
                    nik: '1234567890523456',
                    city: 'Bandung',
                    selected: false
                },    
                {
                    id: 7,
                    name: 'PEVITA CLEO EILEEN PEARCE',
                    nik: '1234567890523456',
                    city: 'Bandung',
                    selected: false
                },
                {
                    id: 8,
                    name: 'PEVITA CLEO EILEEN PEARCE',
                    nik: '1234567890523456',
                    city: 'Bandung',
                    selected: false
                },
                {
                    id: 9,
                    name: 'PEVITA CLEO EILEEN PEARCE',
                    nik: '1234567890523456',
                    city: 'Bandung',
                    selected: false
                },
                {
                    id: 10,
                    name: 'PEVITA CLEO EILEEN PEARCE',
                    nik: '1234567890523456',
                    city: 'Bandung',
                    selected: false
                },
            ],

            rotation: 0,
            ratio: 2/3,
            outline: 6, // zoom
            // imgSrc: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60',
            imgSrc: '',
            // imgSrc: this.$store.getters.getDefaultImage,
            // imgSrc: '/default-face-recognition.png',
            default_img: '/default-face-recognition.png',

            result: '',
            pixel: '',
            area: 100,
            min_scale: 0.1,
            zoomRate: 0.94,

            photo_ktp: '',
            loading_photo_ktp: false,
        }
    },
    computed: {
        ...mapState([
            'load_data_status_face_recognition',
            'face_recognition',
        ]),
        route_name() {
            return this.$route.name;
        },
    },
    watch: {
        route_name(newData, oldData) {
            if (newData === 'PageMediaPhoto' && oldData !== 'PageMediaPhoto')
                this.setEmpty();
        },
        imgSrc(){
            // this.area = 100;
            // this.pixel = '';
            this.rotation = 0;
            // this.ratio = 1;
            // this.ratio = 2/3;
            // this.outline = 6;
            // this.min_scale = 0.1;
            // this.zoomRate = 0.04;
        }
    },
    methods: {
        async getDetailData(nik, index) {
            this.loading_photo_ktp = true;


            this.media[this.current_media_selected].selected = false;

            this.current_media_selected = index;

            this.media[index].selected = true;

            this.media_detail = this.media[index];

            // console.log(this.media[index])

            // await this.$store.dispatch('getPhotoKtpFaceRecognition', [nik]).
            // then((result) => {
            //     if (result.data.photo)
            //         this.photo_ktp = result.data.photo;
                
            //     this.loading_photo_ktp = false;
            // });

            // if (result.data.photo)
            //     this.photo_ktp = result.data.photo;
                
            this.loading_photo_ktp = false;
        },
        getDefaultImage(e) {
            // console.log('error photo')
            e.target.src = this.default_img;
        },
        encryptNik(nik) {
            return encrypt(nik + '&&nik');
        },
        dataURLtoFile(dataurl, filename) {
            const arr = dataurl.split(',')
            const mime = arr[0].match(/:(.*?);/)[1]
            const bstr = atob(arr[1])
            let n = bstr.length
            const u8arr = new Uint8Array(n)
            while (n) {
                u8arr[n - 1] = bstr.charCodeAt(n - 1)
                n -= 1 // to make eslint happy
            }
            return new File([u8arr], filename, { type: mime })
        },
        setEmpty(submit = false) {
            this.showLoading(false);
            this.media = [];
            this.media_detail = {};

            if (!submit) {
                this.area = 100;
                this.pixel = '';
                this.rotation = 0;
                this.ratio = 1;
                this.ratio = 2/3;
                this.outline = 6;
                this.min_scale = 0.1;
                this.zoomRate = 0.04;

                this.imgSrc = '';
                this.imgSrc = this.default_img;
                this.limit = this.getLimit[0];
                this.gender = 'male';
                // console.log('not submit')
            }
            this.$store.commit('setLoadDataStatusFaceRecognition', false);
            this.$store.commit('setFaceRecognition', {});
        },
        async submit() {
            // console.log(this.imgSrc);
            // this.media = [];
            this.setEmpty(true);

            if (this.imgSrc === '/default-face-recognition.png' || this.imgSrc === '' ) {
                this.$swal.fire({
                    icon: 'error',
                    title: 'Image Required!',
                    text: 'PLease choose an image.',
                    // showConfirmButton: false,
                    allowOutsideClick: false
                    // timer: 3000
                });

                return;
            }

            // this.showLoading(true);

            const canvas = this.$refs.clipper.clip();
            // console.log(canvas);
            this.result = canvas.toDataURL("image/jpeg", 1);

            let image = this.dataURLtoFile(this.result);

            // [isNew=true, image, limit='', gender='']
            await this.$store.dispatch('getFaceRecognition', [false, image, parseInt(this.limit), this.gender]);

            // console.log(this.load_data_status_face_recognition.status);

            switch(this.load_data_status_face_recognition.status) {
                case true:

                    if (this.face_recognition.candidates && this.face_recognition.candidates.length > 0) {
                        let media = this.face_recognition.candidates;

                        for (var i = 0; i < media.length; i++) {
                            if (i === 0) {
                                media[i].selected = true;
                            } else {
                                media[i].selected = false;
                            }
                        }

                        this.media = media;
                        this.current_media_selected = 0;
                        // this.media_detail = media[0];

                        // console.log('this.media');

                        this.getDetailData(this.media[0].ktp_number, 0);

                        document.getElementById('mobileSidebarClose').classList.remove('upload-mobile-hide')
                        // document.getElementById('mobileSidebarClose').classList.add('upload-mobile-hide')

                        this.$swal.fire({
                            icon: 'success',
                            title: 'Done!',
                            timer: 3000,
                        });
                    } else {
                        this.error('Data is empty.');
                    }
                    break;
                case 'failed':
                    this.error();
                    break;
                default:
                    this.showLoading(false);
                    break;
            }
        },
        showLoading(show=true) {
            if (show) {
                this.$swal.fire({
                    title: '',
                    html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>Loading...</h4></div>',
                    showConfirmButton: false,
                    allowOutsideClick: false
                });

            } else {
                this.$swal.close();
            }
        },
        error(message=null) {
            this.$swal.fire({
                title: 'Failed!',
                text: (message!==null ? message : 'Something wrong.'),
                icon: 'error',
                // timer: 3000
            });
        },

        openUpload(){
            document.getElementById('mobileSidebarClose').classList.add('upload-mobile-hide')
        },
        closeUpload(){
            document.getElementById('mobileSidebarClose').classList.remove('upload-mobile-hide')
        }
    },
    mounted() {
        // console.log(this.route_name)
        // this.showLoading(false);
        this.setEmpty();
    },
 
}
</script>

<style lang="sass">
    .box--media
        display: flex
        &__sidebar
            flex: 0 0 250px
            padding: 16px
            border-style: solid
            border-right-width: 1px
        &__content
            flex-grow: 1
            position: relative

    .area-preview
        position: relative
        padding-bottom: 150px
        .area-label-info
            overflow: auto

        .label-info
            span
                width: 100%
                display: block
                max-width: 170px
            h3
                &::before
                    content: ': '
        &__information
            flex-grow: 1

        &__thumbnail
            position: relative
            flex: 0 0 300px
            .thumbnail-result
                position: absolute
                top: 0
                left: 0
                width: 300px
                height: 100%
                overflow: auto
                &::-webkit-scrollbar
                    width: 4px
                &::-webkit-scrollbar-track
                    background: $color-border
                &::-webkit-scrollbar-thumb
                    background: darken($color-border, 5% )
                    &:hover
                        background: #555
                &__selected
                    background-color: $color-secondary
                    color: $color-bg

        .preview-blank
            position: absolute
            left: 0
            top: 0
            width: 100%
            height: 100%

    .cover-media
        width: 60px
        img
            width: 60px !important
            height: auto

    @media screen and (min-width: 1024px)
        .thumbnail-result
            &::-webkit-scrollbar
                width: 4px
            &::-webkit-scrollbar-track
                background: $color-border
            &::-webkit-scrollbar-thumb
                background: darken($color-border, 5% )
                &:hover
                    background: #555
    
    @media screen and (max-width: 480px)
        .btn-new-photo
            position: absolute
            bottom: 10px
            right: 18px
        .box--media
            flex-direction: column
            &__sidebar
                position: fixed
                top: 0px
                left: 0px
                width: 100vw
                height: 100vh
                overflow: auto
                background-color: $color-bg
                z-index: 9999999
                display: none
                .btn-primary
                    height: 48px
            .upload-mobile-hide
                display: block
            .analyzed-success,
                display: none
            .area-preview
                flex-direction: column
                &__thumbnail
                    position: fixed
                    bottom: 0
                    left: 0
                    z-index: 999999
                    width: 100vw
                    height: auto
                    overflow: auto
                    background-color: $color-bg
                    border-top-width: 1px
                    border-style: solid
                    .thumbnail-result
                        width: auto
                        position: relative
                        display: flex
                        .list-thumb
                            .flex
                                border-bottom: 0px !important
                                .block
                                    white-space: nowrap


</style>


